<template>
  <div class="navWrap">
    <div class="language" v-on:click="changeLanguage">
      {{language}}
      <!-- <div class="line"></div> -->
    </div>
    <div class="navBarItem first">
      <router-link to="/pcpage/mainpage/home" active-class="activeLink">
        <span>{{ $t("message.home") }}</span>
      </router-link>
    </div>
    <div class="navBarItem">
      <router-link to="/pcpage/mainpage/news" active-class="activeLink">
        <span>{{ $t("message.news") }}</span>
      </router-link>
    </div>
    <div class="navBarItem">
      <router-link to="/pcpage/mainpage/timeline" active-class="activeLink">
        <span>{{ $t("message.timeline") }}</span>
      </router-link>
    </div>
    <div class="navBarItem">
      <router-link to="/pcpage/mainpage/speakers" active-class="activeLink">
        <span>{{ $t("message.guest") }}</span>
      </router-link>
    </div>
    <div class="navBarItem">
      <router-link to="/pcpage/mainpage/awards" active-class="activeLink">
        <span>{{ $t("message.awards") }}</span>
      </router-link>
    </div>
    <div class="navBarItem">
      <router-link to="/pcpage/mainpage/picture" active-class="activeLink">
        <span>{{ $t("message.picture") }}</span>
      </router-link>
    </div>
    <div class="navBarItem">
      <router-link to="/pcpage/mainpage/resource" active-class="activeLink">
        <span>{{ $t("message.resource") }}</span>
    </router-link>
    </div>
    <!-- <div class="navBarItem">
      <router-link to="/pcpage/mainpage/history" active-class="activeLink">
        <span>{{ $t("message.history") }}</span>
      </router-link>
    </div> -->
  </div>
</template>

<script>
import { setup } from "../../locales";
export default {
  name: "navbar",
  data: function() {
    return {
      languageIndex: 0,
      languageList: [
        { 
          name: "cn",
          val: "中"
        },
        {
          name: "en",
          val: "English"
        }
      ]
    };
  },
  computed: {
    language: {
      get() {
        return this.languageList[this.languageIndex].val;
      },
      set() {
        return this.languageList[this.languageIndex].val;
      }
    }
  },

  methods: {
    // 切换语言
    changeLanguage() {
      if (this.languageIndex == this.languageList.length - 1) {
        setup(this.languageList[this.languageIndex].name);
        this.languageIndex = 0;
      } else {
        setup(this.languageList[this.languageIndex].name);
        this.languageIndex++;
      }
    },
    setDefaultLanguage() {
      let currentLanguage = window.localStorage.getItem("localeLanguage");
      for (let i = 0; i < this.languageList.length; i++) {
        if (currentLanguage == this.languageList[i].name) {
          this.language = this.languageList[i].val;
          if (i == this.languageList.length - 1) {
            this.languageIndex = 0;
          } else {
            this.languageIndex = i + 1;
          }
        }
      }
    }
  },
  mounted: function() {
    this.setDefaultLanguage();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.navWrap {
  .language {
    width: 100px;
    height: 48px;
    margin-right: 50px;
    float: right;
    background-color: #f3bc65;
    line-height: 50px;
    text-align: center;
    color: #0d7db0;
    font-size: 28px;
    letter-spacing: 0px;
    cursor: pointer;
  }
  .line {
    width: 100px;
    height: 5px;
    background-color: #f3bc65;
    margin-top: 3px;
  }
  .navBarItem {
    margin-bottom: 43px;
    text-align: center;
    width: 100%;
    font-size: 24px;
    a {
      display: inline-block;
      width: 132px;
      text-align: right;
      color: #fff;
      text-decoration: none;
    }
    a:hover {
        color: #f3bc65;
        font-weight: bold;
    }
    .activeLink {
      color: #f3bc65;
      font-weight: bold;
    }
  }
  .first {
    padding-top: 260px;
  }
}
@media screen and (min-width: 1240px) and (max-width: 1600px) {
    .navWrap {
        .first {
            padding-top: 140px;
        }
    }
}

</style>
